<template>
  <main>
    <v-app-bar
      app
      color="white"
      dark
      flat
    >
      <router-link
        id="app-bar-home-button"
        :to="{name: 'jobs'}"
      >
        <span style="color:black"> <img
          width="200"
          :src="AppBarLogo"
        > </span>
      </router-link>
      <v-toolbar-items
        v-if="isSuperUser"
      >
        <v-menu
          open-on-hover
          offset-y
          transition="slide-x-transition"
          bottom
          right
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              color="primary"
              v-bind="attrs"
              data-cy="appbar-admin-button-services"
              v-on="on"
            >
              Services
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item
              link
              to="/users"
            >
              <v-list-item-title> Users </v-list-item-title>
            </v-list-item>
            <v-list-item
              link
              to="/companies"
            >
              <v-list-item-action>
                <v-list-item-title> Companies </v-list-item-title>
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              link
              to="/jobs"
              data-cy="appbar-admin-button-jobs"
            >
              <v-list-item-action>
                <v-list-item-title> Jobs </v-list-item-title>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu
          open-on-hover
          offset-y
          transition="slide-x-transition"
          bottom
          right
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              color="primary"
              v-bind="attrs"
              data-cy="appbar-admin-button-data"
              v-on="on"
            >
              Data
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item
              link
              to="/payroll-providers"
            >
              <v-list-item-action>
                <v-list-item-title> Payroll Providers </v-list-item-title>
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              link
              to="/markets"
            >
              <v-list-item-action>
                <v-list-item-title> Markets </v-list-item-title>
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              link
              to="/unions"
            >
              <v-list-item-action>
                <v-list-item-title> Unions </v-list-item-title>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
      <v-spacer />
      <v-dialog
        v-model="referAFriend"
        width="850"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="primary"
            outlined
            rounded
            dark
            v-on="on"
            data-cy="appbar-admin-button-refer"
          >
            Refer a Friend
          </v-btn>
        </template>
        <v-card>
          <v-card-title
            class="justify-center"
          >
            Make a Referral
          </v-card-title>
          <v-card-text class=text-center>
            Know anyone that could save time with FPS?
          </v-card-text>
          <v-card-text class=text-center>
            Submit their email address and we'll send them a message!
          </v-card-text>
          <v-row justify="center">
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="email"
                :rules="[rules.email]"
                label="Email"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-row justify="center">
              <v-col cols="auto">
                <v-btn
                  dark
                  color="primary"
                  @click="submit()"
                >
                  Submit
                </v-btn>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  text
                  @click="() => referAFriend = false"
                >
                  Cancel
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-menu
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            color="primary"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            style="cursor:pointer"
            v-if="isSuperUser"
          >
            <a
              href="/admin/"
              target="_blank"
              style="text-decoration: none;"
            >
              <v-list-item-title>
                Django Admin
              </v-list-item-title>
            </a>
          </v-list-item>
          <v-list-item style="cursor:pointer">
            <v-list-item-title @click="logOut">
              Log Out
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <div>
      <router-view @snackbar="(val) => $emit('snackbar', val)" />
    </div>
    <v-footer
      color="primary"
      style="color: white; border-top: 1px solid gray"
    >
      <v-row
        justify="space-between"
        align="end"
      >
        <v-col cols="4">
          <v-row
            wrap
            no-gutters
          >
            <h3> About </h3>
            <v-col cols="12">
              <router-link
                id="footer-contact-us"
                class="footer-button"
                :to="{name:'contactUs'}"
              >
                Contact Us
              </router-link>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4" />
        <v-col cols="auto">
          <div>&copy; {{ new Date().getFullYear() }}</div>
        </v-col>
      </v-row>
    </v-footer>
  </main>
</template>

<script>
import AppBarLogo from '../assets/logo-long.svg';
import { logOut } from '../services/users';
import { getUser } from '../services/users';
import { productionManagerReferral } from "../services/referrals";

export default {
  name: 'App',

  data: () => ({
    rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
    AppBarLogo,
    isSuperUser: false,
    referAFriend: false,
    email: "",
    user: "",
    employeeFirstName: "",
    employeeLastName: "",
  }),
  async mounted() { 
    let current_user = await getUser();
    this.user = current_user['data'];
    this.isSuperUser = current_user['data']['is_superuser'];
    this.employeeFirstName = this.user['firstName']
    this.employeeLastName = this.user['lastName']
  },
  methods: {
    async logOut() {
      console.log('logging out');
      try {
        await logOut();
        this.$router.push({ name: 'login' });
      } catch (e) {
        this.$emit('snackbar', { text: 'You must work at least one day.', color: 'red' });
      }
    },
    async submit() {
      if (this.email === "") {
        this.$emit("snackbar", {
          text: "Please enter an email to send a referral to that person.",
          color: "red",
        });
        return;
      }
      let payload = {
        productionManagerEmail: this.email,
        user: this.user,
        employeeFirstName: this.employeeFirstName,
        employeeLastName: this.employeeLastName,
        isPm: true,
      };
      try {
        await productionManagerReferral(payload);
        this.$router.push({
          name: "referral-success",
          params: {
            email: this.email,
            employeeFirstName: this.employeeFirstName,
            employeeLastName: this.employeeLastName,
          },
        });
      } catch (e) {
        if (e.response.status === 502) {
          this.$emit("snackbar", { text: "502 Bad Gateway", color: "red" });
        } else {
          this.$emit("snackbar", {
            text: "Error Sending Email",
            color: "red",
          });
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
  @import '@/scss/design';

  .date-row {
    border-bottom: 1px solid $gray-light;
  }

  .footer-button {
    text-decoration: none;
    color:white
  }
</style>
